import FontAwesomeIcon from "@/lib/fontawesome";
import { advent22Store } from "@/lib/store";
import { setDefaults as toast_set_defaults } from "bulma-toast";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";

import "@/main.scss";

const app = createApp(App);

app.use(createPinia());
app.component("FontAwesomeIcon", FontAwesomeIcon);

advent22Store().init();

app.mount("#app");

toast_set_defaults({
  duration: 10e3,
  pauseOnHover: true,
  dismissible: true,
  closeOnClick: false,
  type: "is-white",
  position: "top-center",
  animate: { in: "backInDown", out: "backOutUp" },
});
